import { refreshAccessToken } from "@services/auth";

export const ensureFreshAccessToken = async () => {
  const expiresAt = localStorage.getItem("expires_at");
  if (!expiresAt) return;

  const expiryTime = new Date(expiresAt).getTime();
  const currentTime = new Date().getTime();

  // Refresh if token is about to expire in 2 minutes
  if (expiryTime - currentTime < 120000) {
    await refreshAccessToken();
  }
};
